import { render, staticRenderFns } from "./CustomResource.vue?vue&type=template&id=17a1ad7c&scoped=true&"
import script from "./CustomResource.vue?vue&type=script&lang=js&"
export * from "./CustomResource.vue?vue&type=script&lang=js&"
import style0 from "./CustomResource.vue?vue&type=style&index=0&id=17a1ad7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a1ad7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ctorres/Documents/Dev/MCD/lsm-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VTextarea})
